import { createClient } from '@supabase/supabase-js';

// Extremely safe way to get env vars that won't crash browser
const getEnv = (key: string): string | undefined => {
  try {
    // Check for standard global object mostly used in bundlers
    // @ts-ignore
    if (typeof import.meta !== 'undefined' && import.meta.env && import.meta.env[key]) {
      // @ts-ignore
      return import.meta.env[key];
    }
    // Check for process.env (Node/CRA compatibility)
    if (typeof process !== 'undefined' && process.env) {
      return process.env[key];
    }
  } catch (e) {
    return undefined;
  }
  return undefined;
};

// Try all variations of naming
const supabaseUrl = 
  getEnv('VITE_SUPABASE_URL') || 
  getEnv('REACT_APP_SUPABASE_URL') || 
  getEnv('SUPABASE_URL');

const supabaseKey = 
  getEnv('VITE_SUPABASE_ANON_KEY') || 
  getEnv('REACT_APP_SUPABASE_ANON_KEY') || 
  getEnv('SUPABASE_ANON_KEY');

// Only create client if keys exist, otherwise null (triggers fallback mode in dataService)
export const supabase = (supabaseUrl && supabaseKey) 
  ? createClient(supabaseUrl, supabaseKey) 
  : null;